import React from "react";
import { ReactDOM } from "react";
import logo from "./hackathon.png"

function Header(){
    return(
        <div className="flex justify-center m-2">
        <img src={logo}
            className="lg:h-[300px] md:h-[250px] sm:h-[200px]"
        />
        </div>
    )
}

export default Header;